import React from 'react';

interface AbnyWebBadgeProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const AbnyWebBadge: React.FC<AbnyWebBadgeProps> = ({ 
  className = '',
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'px-3 py-1 text-xs gap-2',
    md: 'px-4 py-1.5 text-xs sm:text-sm gap-2.5',
    lg: 'px-5 py-2 text-sm gap-3'
  };

  const iconSizes = {
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-7 h-7'
  };

  return (
    <a
      href="https://abnyweb.in"
      target="_blank"
      rel="noopener noreferrer"
      title="Developed & Powered by ABNY Web (abnyweb.in)"
      className={`inline-flex items-center rounded-full bg-[#181C26] hover:bg-[#202532] border border-[#2C3244] shadow-md hover:shadow-lg transition-all duration-200 group cursor-pointer select-none ${sizeClasses[size]} ${className}`}
    >
      {/* Dark Rounded Icon Box with White Hexagon + ABNY */}
      <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-lg bg-[#262C3D] flex items-center justify-center p-0.5 shrink-0 shadow-inner group-hover:scale-105 transition-transform">
        <svg viewBox="0 0 32 32" className="w-full h-full">
          {/* White Hexagon Shape */}
          <polygon
            points="16,3 27.5,9.5 27.5,22.5 16,29 4.5,22.5 4.5,9.5"
            fill="#FFFFFF"
          />
          {/* ABNY Centered Text */}
          <text
            x="16"
            y="18.5"
            textAnchor="middle"
            fontSize="7.5"
            fontWeight="900"
            fontFamily="Montserrat, system-ui, -apple-system, sans-serif"
            fill="#111827"
            letterSpacing="-0.3"
          >
            ABNY
          </text>
        </svg>
      </div>

      {/* Powered by ABNY Web Label */}
      <div className="flex items-center gap-1.5 whitespace-nowrap">
        <span className="text-[#94A3B8] font-normal tracking-tight">
          Powered by
        </span>
        <span className="text-[#C7D2FE] group-hover:text-white font-bold tracking-tight transition-colors">
          ABNY Web
        </span>
      </div>

      {/* Bright Green Active Indicator Dot */}
      <span className="w-2.5 h-2.5 rounded-full bg-[#10B981] ring-2 ring-[#10B981]/30 shrink-0 animate-pulse" />
    </a>
  );
};
